module.exports = __webpack_public_path__ + "fb62d5d7c82cdd4e71456a2b69bc21a1.svg";